import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { indexCommitment } from './Scroll';
// ============================================
// top MV news
// ============================================

function topHero() {
  const swiper = new Swiper('.swiper.p-index-hero__slider', {
    loop: true,
    speed: 800,
    autoplay: {
      delay: 3600,
    },
  });
}

function topCommitmentSlider() {
  let swiper;
  // 有効化時のオプションを記述
  function initializeSwiper() {
    swiper = new Swiper('.swiper.p-index-commitment__slide', {
      loop: true,
      speed: 1000,
      spaceBetween: 20,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.js-slider__next',
        prevEl: '.js-slider__prev',
      },
      pagination: {
        el: '.js-slider__nav',
        clickable: true,
      },
    });
  }
  // 無効化する用の記述
  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  // if分を用いて横幅に応じて関数を実行
  function handleResize() {
    let w = window.innerWidth;
    if (w <= 1180) {
      ScrollTrigger.refresh();
      if (!swiper) {
        initializeSwiper();
      }
    } else {
      ScrollTrigger.refresh();
      destroySwiper();
      indexCommitment();
    }
  }
  // 初回実行
  handleResize();
  window.addEventListener('resize', handleResize);
}

function topVoice() {
  const swiper = new Swiper('.js-slider-voice__archive', {
    loop: true,
    spaceBetween: 16,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.js-slider-voice__next',
      prevEl: '.js-slider-voice__prev',
    },
    pagination: {
      el: '.js-slider-voice__nav',
      clickable: true,
    },
  });
}

// 施工事例詳細ページスライダー
// ==========================
function caseSlider() {
  const swiper = new Swiper('.p-case__slider.swiper', {
    loop: true,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.js-slider__next',
      prevEl: '.js-slider__prev',
    },
    pagination: {
      el: '.js-slider__nav',
      clickable: true,
    },
  });
}

// こんな家つくれます詳細ページスライダー
// ==========================
function suggestionSlider() {
  const sliderItem = document.querySelectorAll('.swiper.p-single-suggestion-thumbnails__slider .swiper-slide');
  let loop = true;
  if (sliderItem.length < 2) {
    loop = false;
  }

  const swiperThumbnail = new Swiper('.swiper.p-single-suggestion-thumbnails__slider', {
    slidesPerView: 4,
    spaceBetween: 8,
  });
  const swiper = new Swiper('.p-single-suggestion__slider.swiper', {
    loop,
    navigation: {
      nextEl: '.js-slider__next',
      prevEl: '.js-slider__prev',
    },
    thumbs: {
      swiper: swiperThumbnail,
    },
  });
}

// ============================================
// export
// ============================================
export { topHero, topCommitmentSlider, topVoice, caseSlider, suggestionSlider };
